import React from "react";
import Header from "./header";
import Footer from "./footer";

const Layout = ({ children }: { children: any }) => {
  return (
    <div>
      <Header />
      {children}
      <Footer />
    </div>
  );
};

export default Layout;
